import { render } from "./RippleButton.vue?vue&type=template&id=41c54129&scoped=true&ts=true"
import script from "./RippleButton.vue?vue&type=script&lang=ts"
export * from "./RippleButton.vue?vue&type=script&lang=ts"

import "./RippleButton.vue?vue&type=style&index=0&id=41c54129&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41c54129"]])

export default __exports__